module.exports = __webpack_public_path__ + "img/myCard2.2943d2d4.jpg";